<template>
    <el-container>
        <el-header>
            <el-form @submit.native.prevent style="width:100%;padding-top: 10px;">
                <el-row type="flex" class="row-bg" justify="space-between">
                  <query-gather :is-add="true" :is-input="true" :is-query="true" :is-reset="true"
                                :cur-input-tip="curInputTip"
                                @qgAddDeal="setUser(false,'新增用户')" @qgDelAllDeal="handleAllDelete" @qgQueryDeal="getYhxxPage_"
                                @qgResetDeal="chongzhi"></query-gather>
                </el-row>
            </el-form>
        </el-header>
        <el-main style="padding-left: 15px;padding-right:15px;padding-bottom: 10px;">
          <div style="background-color: #ffffff;padding-left: 5px;padding-right:5px;height: 100%;position: relative;">
            <el-table
                ref="userTable"
                :data="tableData"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                border
                size="small "
                style="width:100%;padding: 5px"
                height="calc(100% - 60px)"
                max-height="calc(100% - 60px)"
                @selection-change="handleSelectionChange"
                @sort-change="userSortChange"
                :row-style="tableRowClassName"
                :header-cell-style="{backgroundColor:'#f9f9ff',fontSize: '1.4rem',textAlign:'center',color:'#323232',
                          fontFamily:'PingFang SC',fontWeight:'normal',fontStretch:'normal',height:'6.5vh'}"
            >
              <template v-for="(item,index) in userTitles">
                <template v-if="index ===0">
                  <el-table-column
                      :prop="item.prop"
                      :width="item.width"
                      :label="item.label"
                      :align="item.align"
                      :sortable="item.sortable"
                      show-overflow-tooltip
                      v-if="!item.isFilter">
                    <template slot-scope="scope">
                      <a style="cursor: pointer;color: #46adf5"
                         @click="skFirstItemClickDeal(scope.row)">{{ scope.row.name }}</a>
                    </template>
                  </el-table-column>
                </template>
                <template v-else>
                  <el-table-column
                      :prop="item.prop"
                      :width="item.width"
                      :label="item.label"
                      :align="item.align"
                      :sortable="item.sortable"
                      show-overflow-tooltip
                      v-if="!item.isFilter">
                  </el-table-column>
                  <el-table-column
                      :prop="item.prop"
                      :width="item.width"
                      :label="item.label"
                      :align="item.align"
                      show-overflow-tooltip
                      v-else
                  >
                    <template v-slot:header>
                      {{ item.label }}
                      <el-popover
                          v-if="item.prop==='sex'"
                          @hide="sexPoverHide"
                          placement="bottom"
                          trigger="click">
                        <el-radio-group
                            style="width: 180px;"
                            v-model="sex"
                            :input="sex"
                            >
                          <el-row>
                            <el-col :span="12"  v-for="item in sexMcOptions" :key="item.code" class="popover-radio">
                              <el-radio
                                  :label="item.name"
                                  :key="item.code">
                                {{ item.name }}
                              </el-radio>
                            </el-col>
                          </el-row>
                        </el-radio-group>
                        <i class="el-icon-sxld" v-if="item.prop === 'sex'" slot="reference"/>
                      </el-popover>
                    </template>
                  </el-table-column>
                </template>
              </template>
                <el-table-column label="操作" align="center"   width="300" >
                    <template slot-scope="scope">
                        <span @click="setUserSq(scope.row)" style="padding-left: 1rem">
                              <el-tooltip content="授权" effect="light" >
                                    <img src="~@/assets/images/sq.png" alt=""  style="cursor: pointer;"/>
                              </el-tooltip>
                        </span>
                        <el-tooltip content="删除" effect="light" >
                            <el-popconfirm style="margin-left: 10px" title="确定删除吗？"  @confirm="handleDelete(scope.row)">
                                <img src="~@/assets/images/operates/delete.png" alt="" slot="reference" style="cursor: pointer;"/>
                            </el-popconfirm>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div style="width:100%;position: absolute;bottom: 10px;">
              <pageFooter @current-change="handleCurrentChange" @size-change="handleSizeChange" :rForm="params"></pageFooter>
            </div>
            <user-open :dialog="dialog" @reset="reset"/>
            <userSqOpen :sqdialog="sqdialog" @reset="reset" ref="userSqOpen"/>
          </div>
        </el-main>
    </el-container>
</template>

<script>

  import userOpen from "./open/userOpen.vue";
  import userSqOpen from "./open/userSqOpen.vue";
  import pageFooter from "@/components/pageFooter.vue";
  import QueryGather from "../../components/buttonGather/queryGather";
  import ItemSelectPop from "@/components/tableGather/itemSelectPop.vue";
  export default {
    components: {
      ItemSelectPop,
        userOpen,userSqOpen,pageFooter,QueryGather},
    name: "TabUser",
    data() {
      return {
        loading:false,
        curInputTip:'请输入姓名查询',
        tableData: [],
        sex:'0301',
        userTitles: [
          {prop: 'name', label: '姓名',  align: 'center', sortable: true, isFilter: false,},
          {prop: 'sex', label: '性别', width: 200, align: 'center', sortable: false, isFilter: false,},
          {prop: 'telephone', label: '电话', width: 200, align: 'center', sortable: false, isFilter: false,},
          {prop: 'mobilephone', label: '手机', width: 200, align: 'center', sortable: false, isFilter: false,},
          {prop: 'qq', label: 'QQ', width: 200, align: 'center', sortable: false, isFilter: false,},
          {prop: 'no', label: '序号', width: 200, align: 'center', sortable: true, isFilter: false,},
        ],
        multiple: true,
        sexMcOptions:[],
        params: {
          total: 1,
          size: 20,
          current: 1,
          name: "",
        },
        multipleSelection: [],
        dialog: {
          title: "",
          formVisible: false,
          data: {}
        },
        //用户授权dialog
        sqdialog: {
          formVisible: false,
          data: {},
          jsdata: [],
          defaultTree: [],
          defaultSelect: [],
            defaultSk:[],
        },
        stHeight: "0",
        authority: {},
      }
    },
    mounted() {
      this.init();
      this.getSexOptions();
    },
    methods: {
      sexPoverHide(){
        if (this.params.sex !== '') {
          this.getYhxxPage_();
        }
      },

      getSexOptions(){
        this.request.get('/rm-sdictionary/v1/query/03').then(res => {
          if (res.ok) {
            if (res.data != null) {
              this.sexMcOptions = res.data;

            } else {
              this.$message.info("获取性别选择数据为空");
            }
          } else {
            this.$message.error(res.error.message);
          }
        });
      },


      init() {
        let authList = JSON.parse(localStorage.getItem("thirdAuthority"))['section'];
        this.authority.read = true;
        this.authority.del = true;
        this.authority.edit = true;
        this.authority.query = true;
      },
      skFirstItemClickDeal(row){
        if(this.authority.edit){
          this.setUser(row,'用户信息')
        }else if(this.authority.read){
          this.setUser(null);
        }

      },
      userSortChange(column){
        let params = {
          total: 1,
          size: 20,
          current: 1,
          name:"",
          sortCol: column.prop,
          order: column.order === "descending" ? 1 : 0,
        };
        this.params = {};
        this.params = params;
        this.getYhxxPage_();
      },
      tableRowClassName({row, rowIndex}) {
        return {
          height: '5.83vh',
        };
      },
      //查询
        getYhxxPage_(params){
          if(typeof params !="undefined"){
            this.params.name = params.curInputValue;
          }
            this.params.current = 1
            this.getYhxxPage();
        },
      getYhxxPage() {
        this.request.get("/rm-suser/v1/page", {params: this.params}).then(res => {
          if (res.ok) {
            this.tableData = res.data.records;
            this.params.total = res.data.total;
            this.params.size = res.data.size;
          }
        })
      },
      handleSizeChange(val) {
        this.params.size = val;
        this.params.current = 1
        this.getYhxxPage();
      },
      handleCurrentChange(val) {
        this.params.current = val;
        this.getYhxxPage();
      },
      handleDelete(row){
        this.request.delete("/rm-suser/v1/"+row.id, {params: row.id}).then(res => {
          if (res.ok) {
            this.$message.success("删除成功");
            this.params.current = 1
            this.getYhxxPage();
          }
        })
      },
      handleAllDelete(){
        let selection =[]
        for(let s of this.multipleSelection){
          selection.push(s.id)
        }
        if(!selection){
          this.$message.info("请至少选中一行删除！");
        }
        this.request.delete("/rm-suser/v1/ids",{data:selection}).then(res => {
          if (res.ok) {
            this.$message.success("批量删除成功");
            this.params.current = 1;
            this.getYhxxPage();
          }
        })
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
        this.multiple = !val.length;
      },
      setUser(scope,title){
        if(scope){
          this.request.get("/rm-suser/v1/"+scope.id, {params: scope.id}).then(res => {
            if (res.ok) {
              this.dialog.data = res.data
            }
          })
        }
        this.dialog.title = title
        this.dialog.formVisible = true

      },
      chongzhi(){
        this.params.name =''
        this.params.total = 1;
        this.params.size= 20;
        this.params.current= 1;
        this.getYhxxPage();
      },
      // 表单重置
      reset() {
        this.dialog.data = {}
        this.sqdialog.data = {}
        this.sqdialog.jsdata = {}
        this.getYhxxPage();
      },
      //用户授权
      setUserSq(scope){
        this.request.get("/rm-suser/v1/authorization/"+scope.id, {params: scope.id}).then(res => {
          if (res.ok) {
            this.sqdialog.data = res.data
            this.sqdialog.data.id = scope.id
            this.sqdialog.formVisible = true
              this.sqdialog.defaultSelect = []
              this.sqdialog.defaultSk = []

              //二级菜单isIndeterminate
              for(let i of res.data.list){
                  if(i.children.length === 0){
                      i.isIndeterminate = false
                  }else{
                      let checklenth = 0
                      let checkAll = true
                      for (let ii of i.children){
                          if(ii.hasCheck){
                              checklenth++
                          }

                          let sunlenth = 0
                          for(let iii of ii.children){
                              if(iii.hasCheck){
                                  sunlenth++
                              }
                          }
                          ii.isIndeterminate = sunlenth > 0 && sunlenth < ii.children.length;
                          checkAll = checkAll && ii.isIndeterminate
                      }
                      i.isIndeterminate = checklenth > 0 && checklenth < i.children.length && !checkAll;
                  }
              }
              //select默认选中
              if(res.data.roleIds){
                  this.sqdialog.defaultSelect =  res.data.roleIds
              }

              //select默认选中
              if(res.data.resList){
                  for(let i of res.data.resList){
                      if(i.hasCheck){
                          this.sqdialog.defaultSk.push(i.rescd)
                      }
                  }
              }

            //console.log(' this.sqdialog', this.sqdialog)

          }
        })
        //查询角色信息
        this.request.get("/rm-srole/v1/query/roleList",).then(res => {
          if (res.ok) {
            this.sqdialog.jsdata = res.data
          }
        })
      }
    },
    created() {
      this.getYhxxPage();
        let windowHeight = document.documentElement.clientHeight || document.bodyclientHeight;
        this.stHeight = windowHeight - 260;
    }
  }
</script>
<style scoped>
.el-icon-sxld {
  width: 10px;
  height: 9px;
  margin-left: 10px;
  cursor: pointer;
  background: url('../../assets/icons/sxld.png');
}
    ::v-deep .el-main {
      display: block;
      flex: 1;
      flex-basis: auto;
      overflow: auto;
      box-sizing: border-box;
      padding: 10px;
    }
</style>
